import React from "react";
import {
  FaUsers,
  FaBook,
  FaToilet,
  FaHeartbeat,
  FaMedkit,
  FaGraduationCap,
} from "react-icons/fa";
import { IconType } from "react-icons";

// Create a wrapper component for icons to fix TypeScript errors
const IconWrapper = ({ Icon }: { Icon: IconType }) => {
  // Using the component as any type to bypass TypeScript errors
  const IconComponent = Icon as any;
  return <IconComponent className="h-10 w-10 text-primary" />;
};

const focusAreas = [
  {
    title: "Women Empowerment",
    description:
      "We provide training and support to help women achieve financial independence and leadership roles within their communities.",
    icon: <IconWrapper Icon={FaUsers} />,
  },
  {
    title: "Skill Development",
    description:
      "Our programs offer vocational training and skill-building workshops, enhancing employment opportunities for youth and adults.",
    icon: <IconWrapper Icon={FaBook} />,
  },
  {
    title: "Rural Sanitation",
    description:
      "We promote hygiene and reduce disease by constructing sanitation facilities and educating communities on proper waste management.",
    icon: <IconWrapper Icon={FaToilet} />,
  },
  {
    title: "Cancer Awareness",
    description:
      "We conduct cancer screenings and educational workshops, aiming for early detection and offering support to affected individuals and families.",
    icon: <IconWrapper Icon={FaHeartbeat} />,
  },
  {
    title: "Health Initiatives",
    description:
      "We run health camps and provide medical support, focusing on both preventive and curative healthcare in underserved communities.",
    icon: <IconWrapper Icon={FaMedkit} />,
  },
  {
    title: "Rural Education",
    description:
      "We improve access to quality education by supporting schools, providing learning materials, and training teachers in remote areas.",
    icon: <IconWrapper Icon={FaGraduationCap} />,
  },
];

const AreasOfFocus: React.FC = () => {
  return (
    <section className="section-padding bg-light">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h6 className="text-primary font-semibold mb-2">Areas of Focus</h6>
          <h2 className="text-3xl md:text-4xl font-bold text-dark">
            What Do We Do?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {focusAreas.map((area, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="mb-4">{area.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-dark">
                {area.title}
              </h3>
              <p className="text-gray-600">{area.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasOfFocus;
